export default __webpack_public_path__ + "static/media/Servicios-orange.ba87e1be.svg";